import { useState, useEffect } from "react";
import { getDynamicContent } from "../utils";

const CookieDisclaimer = () => {
  const [content, setContent] = useState(null);
  const [contentError, setContentError] = useState(null);
  const [isModalOpen, setModalIsOpen] = useState(true);

  const contentPath =
    "/sitecore/content/Teamcare/Components/Content/Cookie Disclaimer/Cookie Disclaimer";
  const contentClass =
    "CSF.Web.Teamcare.Models.sitecore.templates.TeamCare.Components.Content.CookieDisclaimer";

  useEffect(() => {
    loadCookieDisclaimerContent();
  }, []);

  const closeModal = () => {
    setModalIsOpen(false);
    setCookie();
  };

  const loadCookieDisclaimerContent = () => {
    getDynamicContent(contentPath, contentClass)
      .then(content => {
        setContent(content);
      })
      .catch(contentError => {
        setContentError(contentError);
      });
  };

  const setCookie = () => {
    const expiresDate = new Date();
    expiresDate.setMonth(expiresDate.getMonth() + 1);
    document.cookie = `disclaimerCookie=; expires=${expiresDate.toUTCString()}; path=/; secure; samesite=none`;
  };

  const isDisclaimerCookieSet = () => {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName] = cookies[i].split("=");
      if (cookieName === "disclaimerCookie") {
        return true;
      }
    }
    return false;
  };

  const learnMoreLink = () => {
    window.open("/cookie-policy", "_blank");
  };

  return (
    <>
      {isModalOpen &&
      !isDisclaimerCookieSet() &&
      content !== null &&
      contentError === null ? (
        <div className="cookie-disclaimer-modal">
          <div className="disclaimer-modal-content">
            <div className="disclaimer-modal-title">{content.Title}</div>
            <button className="disclaimer-close-button" onClick={closeModal}>
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="disclaimer-modal-body">{content.Description}</p>
            <div className="disclaimer-modal-footer">
              <button
                className="btn btn-primary btn-small"
                onClick={learnMoreLink}
              >
                {content.LearnMoreButtonText}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CookieDisclaimer;
